import React, { useEffect } from "react"
import { LanguagePickerSelector } from "../language-picker/LanguagePickerSelector"
import { FooterLink } from "./FooterLink"
import { BodyTextRegular } from "../typography/text"
import { useTranslation } from "react-i18next"
import { translationKeys } from "../../util/translationKeys"

import { routes } from "../../routes"
import {
  LEGAL_LAST_UPDATED_MARKETING,
  LEGAL_LAST_UPDATED_PRIVACY,
  LEGAL_LAST_UPDATED_TERMS,
  LEGAL_VERSION_MARKETING,
  LEGAL_VERSION_PRIVACY,
  LEGAL_VERSION_TERMS,
  PARTNER_COMPANY_NAME,
  PARTNER_DATA_PROCESSORS,
  PARTNER_PARTNERS,
  PARTNER_SHORT_NAME,
  PARTNER_VAT,
  PARTNER_SUPPORT_EMAIL,
  language,
  LEGAL_CONTACT_INFO,
} from "../../util/legal-general"
import { showHeapsGoBranding } from "../../util/show-heapsgo-branding"
import { initializeAnalytics } from "../cookie/utils"
// import { InterfaceContext } from "../../context/InterfaceContext"
import HeapsLogo from "../../assets/images/heaps-logo.svg"

const COOKIEYES_URL = process.env.GATSBY_COOKIEYES_URL

const Logo = process.env.GATSBY_LOGO || ""

const SUPPORT_CHAT = process.env.GATSBY_SUPPORT_CHAT || ""
const SUPPORT_EMAIL = process.env.GATSBY_SUPPORT_EMAIL || ""
const SUPPORT_WEB = process.env.GATSBY_SUPPORT_WEB || ""
const GATSBY_COOKIES = process.env.GATSBY_COOKIES || ""
const GATSBY_TERMS = process.env.GATSBY_TERMS || ""
const GATSBY_PRIVACY = process.env.GATSBY_PRIVACY || ""
const EXTERNAL_REDIRECT_LINK = process.env.GATSBY_EXTERNAL_REDIRECT_LINK || ""
const APP_VERSION = process.env.GATSBY_APP_VERSION

export const linkToExternalLegalPages =
  !language ||
  !PARTNER_SHORT_NAME ||
  !PARTNER_COMPANY_NAME ||
  !PARTNER_VAT ||
  !PARTNER_DATA_PROCESSORS ||
  !PARTNER_PARTNERS ||
  !LEGAL_VERSION_TERMS ||
  !LEGAL_LAST_UPDATED_TERMS ||
  !LEGAL_VERSION_PRIVACY ||
  !LEGAL_LAST_UPDATED_PRIVACY ||
  !LEGAL_VERSION_MARKETING ||
  !LEGAL_LAST_UPDATED_MARKETING ||
  !LEGAL_CONTACT_INFO ||
  !PARTNER_SUPPORT_EMAIL

export const Footer = () => {
  const { t } = useTranslation()
  // const { setCookieModalVisible } = useContext(InterfaceContext)

  const EXTERNAL_REDIRECT_TEXT =
    process.env.GATSBY_EXTERNAL_REDIRECT_TEXT ||
    t(translationKeys.comboCateringAndEvents)

  useEffect(() => {
    // footer is visible on every page
    initializeAnalytics()
  }, [])

  return (
    <div className="flex w-full flex-col border-t border-border-base items-center justify-center bg-backgroundBranded mt-auto">
      <div className="flex w-full max-w-sectionMaxWidth px-4 flex-col md:flex-row gap-6 items-start md:items-center justify-between pt-6 pb-4">
        <img src={Logo} className="h-6 min-h-6 max-h-6" />
        <div className="flex flex-col md:flex-row gap-3 md:gap-6">
          {EXTERNAL_REDIRECT_LINK !== "" && (
            <FooterLink href={EXTERNAL_REDIRECT_LINK}>
              {EXTERNAL_REDIRECT_TEXT}
            </FooterLink>
          )}
          {SUPPORT_CHAT !== "" && (
            <FooterLink href={SUPPORT_CHAT}>
              {t(translationKeys.comboProfileSupport)}
            </FooterLink>
          )}
          {SUPPORT_EMAIL !== "" && (
            <FooterLink href={`mailto:${SUPPORT_EMAIL}`}>
              {t(translationKeys.comboProfileSupportEmail)}
            </FooterLink>
          )}
          {!COOKIEYES_URL && (
            <FooterLink
              href={
                linkToExternalLegalPages ? GATSBY_COOKIES : routes.legal.cookies
              }
              internalLink={linkToExternalLegalPages ? false : true}
            >
              {t(translationKeys.cookies)}
            </FooterLink>
          )}
          <FooterLink
            href={linkToExternalLegalPages ? GATSBY_TERMS : routes.legal.terms}
            internalLink={linkToExternalLegalPages ? false : true}
          >
            {t(translationKeys.comboProfileTerms)}
          </FooterLink>
          <FooterLink
            href={
              linkToExternalLegalPages ? GATSBY_PRIVACY : routes.legal.privacy
            }
            internalLink={linkToExternalLegalPages ? false : true}
          >
            {/* TODO translation */}
            Privacy
          </FooterLink>
          {SUPPORT_WEB !== "" && (
            <FooterLink href={SUPPORT_WEB}>
              {t(translationKeys.comboProfileSupportWeb)}
            </FooterLink>
          )}
        </div>
      </div>
      <div className="w-full h-px bg-border-base" />
      <div className="flex flex-col md:flex-row w-full justify-between items-start md:items-center max-w-sectionMaxWidth px-4 gap-6 md:gap-0 pt-4 pb-6">
        <div className="flex items-center gap-3 md:gap-6">
          <LanguagePickerSelector className="text-xs md:text-sm" />
          {/* {!COOKIEYES_URL && (
            <>
              <div className="size-1.5 rounded-3xl bg-background-disabled" />
              <TextBase
                fontFamily="Inter400"
                className="text-xs md:text-sm text-foreground-base cursor-pointer hover:text-ctaMain"
                onClick={() => setCookieModalVisible(true)}
              >
                {t(translationKeys.webCookiePreferencesTitle)}
              </TextBase>
            </>
          )} */}
          <div className="size-1.5 rounded-3xl bg-background-disabled" />
          <BodyTextRegular className="text-xs md:text-sm text-foreground-subtle">
            {`Version: ${APP_VERSION?.slice(0, 5)?.toLocaleUpperCase()}`}
          </BodyTextRegular>
        </div>
        {showHeapsGoBranding && (
          <div className="flex flex-col gap-6 md:gap-0 md:justify-between">
            <div className="flex flex-row gap-3 items-center">
              <BodyTextRegular className="text-foreground-base">
                Powered by
              </BodyTextRegular>
              <HeapsLogo />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
